import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function CubeIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M13.194 5.125 8 8m0 0L2.806 5.125M8 8v5.783m5.5-3.312V5.529c0-.208 0-.313-.03-.406a.6.6 0 0 0-.132-.221c-.066-.072-.158-.123-.34-.224L8.474 2.175c-.173-.096-.26-.144-.352-.163a.6.6 0 0 0-.246 0c-.092.02-.179.067-.352.163L3.003 4.678c-.183.101-.275.152-.341.224a.6.6 0 0 0-.131.221c-.031.093-.031.198-.031.406v4.942c0 .208 0 .313.03.406a.6.6 0 0 0 .132.221c.066.072.158.123.34.224l4.523 2.503c.173.096.26.144.352.163a.6.6 0 0 0 .246 0c.092-.02.179-.067.352-.163l4.522-2.503c.183-.101.275-.152.341-.224a.6.6 0 0 0 .131-.221c.031-.093.031-.198.031-.406" /></svg>
  );
}

export default CubeIcon;
